/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ColorHarmonyIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Color Harmony',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m15.75,2H4.25c-1.24023,0-2.25,1.00928-2.25,2.25v11.5c0,1.24072,1.00977,2.25,2.25,2.25h11.5c1.24023,0,2.25-1.00928,2.25-2.25V4.25c0-1.24072-1.00977-2.25-2.25-2.25Zm0,1.5c.41309,0,.75.33643.75.75v5h-5.75V3.5h5Zm-12.25.75c0-.41357.33691-.75.75-.75h5v5.75H3.5v-5Zm.75,12.25c-.41309,0-.75-.33643-.75-.75v-5h5.75v5.75h-5Zm12.25-.75c0,.41357-.33691.75-.75.75h-5v-5.75h5.75v5Z"
      fill="currentColor"
    />
    <rect
      x="10.0687"
      y="3.11436"
      width="6.95914"
      height="6.69751"
      fill="currentColor"
      opacity=".5"
    />
    <rect
      x="10.0687"
      y="10.11436"
      width="6.95914"
      height="6.69751"
      fill="currentColor"
      opacity=".12"
    />
    <rect
      x="3.0687"
      y="10.11436"
      width="6.95914"
      height="6.69751"
      fill="currentColor"
      opacity=".3"
    />
  </svg>`;
};
